$(window).load(function() {
    var $container = $(".portfolioContainer");
    $container.isotope({
        filter: "*",
        animationOptions: {
            duration: 750,
            easing: "linear",
            queue: false
        }
    });

    $(".portfolioFilter a").click(function() {
        $(".portfolioFilter .current").removeClass("current");
        $(this).addClass("current");

        var selector = $(this).attr("data-filter");
        $container.isotope({
            filter: selector,
            animationOptions: {
                duration: 750,
                easing: "linear",
                queue: false
            }
        });
        return false;
    });

    // $(function() {
    $("#dialog-confirm").dialog({
        resizable: false,
        draggable: false,
        height: 300,
        width: 320,
        modal: true
    });

    $("#dialog-confirm").on("click", "#btn-close", function() {
        $(this)
            .closest("#dialog-confirm")
            .dialog("close");
    });

    $("#dialog-confirm").bind("clickoutside", function() {
        $(this)
            .closest("#dialog-confirm")
            .dialog("close");
    });

    $(".ui-widget-overlay").click(function() {
        $("#dialog-confirm").dialog("close");
    });

    // });
});
